module.exports = __webpack_public_path__ + "img/Img35_H02_701237_12-122_Carillon-Pointe-Fortune-1re-coulee-beton_juil1960.a58eba64.jpg";